import { render, staticRenderFns } from "./attendance-ranking.vue?vue&type=template&id=5b0a1979&"
import script from "./attendance-ranking.vue?vue&type=script&lang=js&"
export * from "./attendance-ranking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports